import React from "react";
import Icon from "components/AppIcon";

const termSections = [
  {
    title: "Investment Structure",
    icon: "Layers",
    items: [
      { label: "Vehicle Type", value: "Special Purpose Vehicle (SPV)" },
      { label: "Jurisdiction", value: "England & Wales" },
      { label: "Legal Form", value: "Limited Partnership" },
      { label: "Regulatory Status", value: "FCA Authorised (AIFMD)" },
      { label: "Minimum Commitment", value: "£5,000,000" },
      { label: "Target Close", value: "30 June 2026" },
    ],
  },
  {
    title: "Economics",
    icon: "PoundSterling",
    items: [
      { label: "Management Fee", value: "1.5% p.a. on committed capital" },
      { label: "Carried Interest", value: "20% above 8% hurdle" },
      { label: "Preferred Return", value: "8% p.a. (cumulative)" },
      { label: "Catch-up", value: "100% to GP until 80/20 split" },
      { label: "Platform Fee", value: "0.25% on deployment" },
      { label: "Monitoring Fee", value: "£150,000 p.a. (post-construction)" },
    ],
  },
  {
    title: "Governance Rights",
    icon: "Shield",
    items: [
      { label: "Board Representation", value: "1 seat per £20m committed" },
      { label: "Veto Rights", value: "Material asset disposals, refinancing" },
      { label: "Information Rights", value: "Quarterly reports, annual audit" },
      { label: "Advisory Committee", value: "Investors >£10m eligible" },
      { label: "Key Person Clause", value: "Applies to 3 named individuals" },
      { label: "LPAC Consent", value: "Required for conflicts of interest" },
    ],
  },
  {
    title: "Exit Provisions",
    icon: "LogOut",
    items: [
      { label: "Target Exit", value: "Year 8–10 (2033–2035)" },
      { label: "Exit Routes", value: "Trade sale, secondary, IPO, refinancing" },
      { label: "Lock-up Period", value: "3 years from first close" },
      { label: "Transfer Restrictions", value: "GP consent required" },
      { label: "Drag-along Rights", value: "75% LP vote triggers" },
      { label: "Tag-along Rights", value: "Pro-rata participation guaranteed" },
    ],
  },
];

const tokenisationStatus = {
  enabled: true,
  tokenStandard: "ERC-3643 (T-REX)",
  transferRestrictions: "Whitelisted wallets only (KYC/AML verified)",
  secondaryTrading: "Pending — target Q4 2026",
  custodian: "Fireblocks institutional custody",
};

export default function DealTermsTab() {
  return (
    <div className="space-y-6">
      {/* Term Sections */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {termSections?.map((section) => (
          <div key={section?.title} className="card">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-md flex items-center justify-center" style={{ background: "rgba(59,76,76,0.08)" }}>
                <Icon name={section?.icon} size={16} color="var(--color-primary)" />
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground">{section?.title}</h3>
            </div>
            <div className="space-y-2">
              {section?.items?.map((item) => (
                <div key={item?.label} className="flex justify-between items-start gap-3 py-2 border-b border-border last:border-0">
                  <span className="font-caption text-sm text-muted-foreground flex-shrink-0">{item?.label}</span>
                  <span className="font-caption text-sm font-medium text-foreground text-right">{item?.value}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {/* Tokenisation Readiness */}
      <div className="card border-2 border-accent/30">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-md flex items-center justify-center" style={{ background: "rgba(59,76,76,0.15)" }}>
            <Icon name="Coins" size={18} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="font-heading text-base font-semibold text-foreground">Tokenisation Readiness</h3>
            <p className="font-caption text-xs text-muted-foreground">RWA digital rails enabled</p>
          </div>
          <div className="ml-auto flex items-center gap-2 px-3 py-1.5 rounded-full bg-success/10">
            <div className="w-2 h-2 rounded-full bg-success" />
            <span className="font-caption text-xs font-medium text-success">Enabled</span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            { label: "Token Standard", value: tokenisationStatus?.tokenStandard, icon: "Code" },
            { label: "Transfer Restrictions", value: tokenisationStatus?.transferRestrictions, icon: "Lock" },
            { label: "Secondary Trading", value: tokenisationStatus?.secondaryTrading, icon: "ArrowLeftRight" },
            { label: "Custody", value: tokenisationStatus?.custodian, icon: "Shield" },
          ]?.map((item) => (
            <div key={item?.label} className="p-3 rounded-md bg-muted/50">
              <div className="flex items-center gap-2 mb-1">
                <Icon name={item?.icon} size={13} color="var(--color-primary)" />
                <span className="font-caption text-xs text-muted-foreground">{item?.label}</span>
              </div>
              <p className="font-caption text-sm font-medium text-foreground">{item?.value}</p>
            </div>
          ))}
        </div>
        <p className="font-caption text-xs text-muted-foreground mt-4 flex items-center gap-1.5">
          <Icon name="Info" size={12} />
          Tokenisation is subject to regulatory approval and investor eligibility verification. This is a placeholder for demonstration purposes.
        </p>
      </div>
    </div>
  );
}